import React, { Component } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';

import loader from '../../assets/loader.gif';
import exit from '../../assets/icons/white/exit.png';

export default class FormEdit extends Component {
  constructor(props) {
    super();
    this.state = {
      formType: '',
      theCharge: 0,
      thePlan: 0,
      theSP: '',
      preclean: false,
      oldSP: '',
      addtlService: [{service:'',price:''}],
    }
  }

  removeService = i => {
    console.log(i);
    let newArr = this.state.addtlService
    newArr.splice(i, 1);

    console.log(newArr);
    this.setState({
      addtlService: newArr,
    })
  }

  changeServices = (e, i, t) => {
    console.log(e);
    console.log(i);
    console.log(t);
    let allServices = this.state.addtlService;

    if (allServices[i]) {
      allServices[i][t] = e;
    } else {
      allServices[i] = {};
      allServices[i][t] = e;
    }

    this.setState({
      addtlService: allServices
    })
  }

  addService = () => {
    let newArr = this.state.addtlService
    newArr.push('');

    console.log(newArr);
    this.setState({
      addtlService: newArr,
    })
  }

  switchSelect = e => {
    let theContainer = e.target.closest('.switchType').closest('.selectGroup');
    let theValue = e.target.value;

    if (theContainer.classList.contains('single')) {
      theContainer.classList.remove('single');
    }
    if (theContainer.classList.contains('range')) {
      theContainer.classList.remove('range');
    }
    if (theContainer.classList.contains('multiple')) {
      theContainer.classList.remove('multiple');
    }

    theContainer.classList.add(theValue);
  }

  changeType = e => {
    let theValue = e.target.value;
    if (e.target.value === 'New Account' || e.target.value === 'Crew Change' || e.target.value === 'Account Credit' || e.target.value === 'Account Cancellation') {
      this.recalcOwed();
    }
    this.setState({
      formType: '',
    });



    setTimeout((function() {
      this.setState({
        formType: theValue,
      });
    }).bind(this), 50);
  }

  toggleHide = (e, type) => {
    let theToggle = e.target;
    let theContainer = e.target.closest('.hideGroup');
    let theCheck = e.target.getElementsByClassName('theCheck')[0];


    if (theCheck.checked === true) {
      theCheck.checked = false;
    } else {
      theCheck.checked = true;
    }
    if (theContainer.classList.contains('isActive')) {
      theContainer.classList.remove('isActive');
    } else {
      theContainer.classList.add('isActive');
    }

    if (type === 'pre') {
      this.setState({
        preclean: theCheck.checked
      })
    }

  }

  editForm = e => {
    e.preventDefault();
    console.log(e);

    console.log(this.state.formType);

    let formData = {};
    let today = new Date();
    let formattedToday = new Date(today.getTime() + Math.abs(today.getTimezoneOffset()*60000));
    formattedToday = (formattedToday.getMonth()+1) + '/' + formattedToday.getDate() + '/' + formattedToday.getFullYear() + ' ' + today.getHours() + ":" + today.getMinutes();


    let finalForm = [];

    if (this.state.formType === 'New Account') {
      formData = {
        "type": this.state.formType,
        "date": formattedToday,
        "Start Date": document.getElementById('theStart').value,
        "Monthly Amount": document.getElementById('theMonthly').value,
        "Franchise": this.props.spList.filter(e => e.fields['Number'] === this.props.currentRecord['SP Number'])[0].fields['SP Name'],
        "Order Supplies": document.getElementById('theSupplies').value,
      }
      if (this.state.theCharge > 0) {
        formData["Terms"] = document.getElementById('theTerms1').value + ' @ ' + document.getElementById('theTerms2').value;
      }
      if (this.state.preclean) {
        formData["Pre-Clean Charge"] = document.getElementById('preCharge').value;
        formData["Pre-Clean Date"] = document.getElementById('preDate').value;
      }
    } else if (this.state.formType === 'Account Increase' || this.state.formType === 'Account Decrease') {
      formData ={
        "type": this.state.formType,
        "date": formattedToday,
        "Old Monthly": this.props.currentRecord['Monthly Amount'],
        "New Monthly": document.getElementById('theMonthly').value,
        "Effective Date": document.getElementById('theDate').value,
        "Notes": document.getElementById('theNotes').value
      }

      if (document.getElementById('changeSq').checked) {  formData["Actual Sq Footage"] = document.getElementById('theSqFt').value; }
      if (document.getElementById('changeFreq').checked) {  formData["Times per Week"] = document.getElementById('theFrequency').value; }
      if (document.getElementById('changeAddress').checked) { formData["New Address"] = document.getElementById('theAddress').value; }
    } else if (this.state.formType === 'Crew Change') {
      formData ={
        "type": this.state.formType,
        "date": formattedToday,
        "Old Crew": document.getElementById('oldFranch').value,
        "Last Date": document.getElementById('lastDate').value,
        "Replaceable": document.getElementById('replaceable').value,
        "New Crew": document.getElementById('newFranch').value,
        "New SP Start": document.getElementById('newStart').value,
        "Notes": document.getElementById('theNotes').value
      }
    } else if (this.state.formType === 'Account Credit') {
      let missedDates = '';
      let missedTotal = 0;

      if (document.getElementById('missedType').className.split(' ')[2] === 'single') {
        missedDates = document.getElementById('dateMissed').value;
        missedTotal = 1;
      } else if (document.getElementById('missedType').className.split(' ')[2] === 'range') {
        missedDates = document.getElementById('rangeFrom').value + ' - ' + document.getElementById('rangeTo').value;

        let weeksInRange = (Math.floor((Date.parse(document.getElementById('rangeTo').value) - Date.parse(document.getElementById('rangeFrom').value)) / 86400000)/7);

        if (this.props.currentRecord['Times per Week'].replace(/\s+/g, '').length === 2) {
          missedTotal = Math.ceil(parseInt(this.props.currentRecord['Times per Week'].replace(/\s+/g, '').toLowerCase().split('x')[0]) * weeksInRange);
        }
      } else if (document.getElementById('missedType').className.split(' ')[2] === 'multiple') {
        missedDates = document.getElementById('dateMulti').value.replace(/\s+/g, '').split(',');
        missedTotal = missedDates.length;
      }

      formData ={
        "type": this.state.formType,
        "date": formattedToday,
        "Missed Dates": missedDates,
        "Services Missed": missedTotal,
        "Charge": document.getElementById('chargeFranch').value,
        "Notes": document.getElementById('theNotes').value
      }
    } else if (this.state.formType === 'Additional Service') {
      let theTotal = 0;
      for (var i in this.state.addtlService) {
        theTotal += parseInt(this.state.addtlService[i].price.replace('$', '').split(' ')[0]);
      }

      formData ={
        "type": this.state.formType,
        "date": formattedToday,
        "Service Date": document.getElementById('addtlDate').value,
        "Total Price": theTotal,
        "Services": this.state.addtlService,
        "Notes": document.getElementById('theNotes').value
      }
    } else if (this.state.formType === 'Account Cancellation') {
      formData ={
        "type": this.state.formType,
        "date": formattedToday,
        "Franchise": this.props.spList.filter(e => e.fields['Number'] === this.props.currentRecord['SP Number'])[0].fields['SP Name'],
        "Cancel Date": document.getElementById('stopDate').value,
        "Replaceable": document.getElementById('replaceable').value,
        "Notes": document.getElementById('theNotes').value
      }
    }



    if (this.props.currentRecord['Form History']) {
      finalForm = JSON.parse(this.props.currentRecord['Form History']);
      finalForm.push(formData);
    } else {
      finalForm = [formData]
    }

    let fullDataSet = {
      "Form History": JSON.stringify(finalForm)
    }
    let finalPush = {"fields": fullDataSet}
    console.log(finalPush);
    this.props.submitForm(finalPush, formData);
  }

  spChangeHandler = e => {
    this.recalcOwed();
    console.log('change handler!!!');
    this.props.spChangeHandler(e);
  }

  recalcOwed = () => {
    let theMonthly = parseInt(this.props.currentRecord['Monthly Amount']);
    if (this.props.currentRecord['Monthly CPOP']) {
      theMonthly = theMonthly - parseInt(this.props.currentRecord['Monthly CPOP']);
    }

    let theSP = '';
    if (this.props.spList.length > 0) {
      theSP = this.props.spList.filter(e => e.fields['Number'] === this.props.currentRecord['SP Number'])[0];
    }

    if (!theSP) {return;}

    let allOwed = 0;
    if (theSP.fields['Owed']) {
      allOwed += parseInt(theSP.fields['Owed']);
    }
    if (theSP.fields['RP Due']) {
      allOwed += parseInt(theSP.fields['RP Due']);
    }

    console.log('theMonthly - ' + theMonthly);
    console.log(theSP);

    if ((allOwed - theMonthly) < 0) {
      let theNewChargeable = 0;

      theNewChargeable = ((allOwed - theMonthly) * -1);

      this.setState({
        theCharge: theNewChargeable,
        theSP: theSP,
      })
    } else {
      let theNewChargeable = 0;

      theNewChargeable = allOwed - theMonthly;

      this.setState({
        thePlan: theNewChargeable,
        theSP: theSP,
      })
    }
  }

  componentDidMount() {
    if (this.props.viewType === 'edit') {
      this.setState({
        formType: this.props.formData.type,
      });
    }
  }
  // Render
  // ----------------------------------------------------
  render() {
    const { formData, viewType, currentRecord } = this.props;

    let theClasses= "FormWrapper Edit";
    if (viewType === 'add') {
      theClasses += ' show'
    }

    return (
      <div className={theClasses}>
          <div className="navIcon softGrad--primary exit" onClick={this.props.closeFormHandler}>
            <img src={exit} alt="exit" />
          </div>
        <div className="FormModal">
          <div className="inner">

            <div className="intro formRow formModalHeader">
              <h2>Add Form</h2>
              <h4>{currentRecord['Company Name']}</h4>
            </div>

            <div className="formRow">
              <label for="type">Form Type</label>
              <select id="type" value={this.state.formType} onChange={this.changeType}>
                <option value="">Select Type</option>
                <option>Account Increase</option>
                <option>Account Decrease</option>
                <option>New Account</option>
                <option>Crew Change</option>
                <option>Account Credit</option>
                <option>Additional Service</option>
                <option>Account Cancellation</option>
              </select>

              <br/>
              <br/>
              <h2>{this.state.formType}</h2>

            </div>

            <div className="formRow subForm">
              <form id="addForm" onSubmit={this.editForm}>
                {this.getFields}
              </form>
            </div>

          </div>
        </div>
      </div>
    )
  }
  get getFields() {
    let fullAddress = '';
    let addr1 = this.props.currentRecord['Address 1'];
    let addr2 = this.props.currentRecord['Address 2'];
    let city = this.props.currentRecord['City'];
    let zip = this.props.currentRecord['Zip'];

    if (addr1) {
      fullAddress = addr1;
      if (city) {fullAddress = fullAddress + ', ' + city + ', FL';} else {fullAddress = fullAddress + ', FL';}
      if (zip) {fullAddress = fullAddress + ', ' + zip;}
    }


    if (this.state.formType === 'Account Increase' || this.state.formType === 'Account Decrease') {
      return (
        <div className="theFields">
          <div className="fieldGroup">
            <div className="fieldItem">
              <label>New Amount</label>
              <input id="theMonthly" defaultValue={this.props.currentRecord['Monthly Amount']} />
            </div>
          </div>

          <div className="fieldGroup hideGroup">
            <div className="fieldItem theToggle" onClick={(e)=>this.toggleHide(e, '')}>
              <label for="changeSq">Square Footage has Changed</label>
              <input id="changeSq" className="theCheck" type="checkbox" />
            </div>
            <div className="fieldItem">
              <label>New Square Footage</label>
              <input id="theSqFt" defaultValue={this.props.currentRecord['Actual Sq Footage']} />
            </div>
          </div>

          <div className="fieldGroup hideGroup">
            <div className="fieldItem theToggle" onClick={(e)=>this.toggleHide(e, '')}>
              <label for="changeFreq">Frequency has Changed</label>
              <input id="changeFreq" className="theCheck" type="checkbox" />
            </div>
            <div className="fieldItem">
              <label>New Frequency</label>
              <input id="theFrequency" defaultValue={this.props.currentRecord['Times per Week']} />
            </div>
          </div>

          <div className="fieldGroup hideGroup">
            <div className="fieldItem theToggle" onClick={(e)=>this.toggleHide(e, '')}>
              <label for="changeAddress">Address has Changed</label>
              <input id="changeAddress" className="theCheck" type="checkbox" />
            </div>
            <div className="fieldItem">
              <label>New Address</label>
              <input id="theAddress" defaultValue={fullAddress} />
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Date of Change</label>
              <input id="theDate" type="date" />
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Notes</label>
              <textarea id="theNotes" rows="4" />
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Remember to export a new proposal!!!</label>
            </div>
          </div>

          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    } else if (this.state.formType === 'New Account') {
      return (
        <div className="theFields">
          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Start Date</label>
              <input id="theStart" defaultValue={this.props.currentRecord['Start Date']} />
            </div>
            <div className="fieldItem">
              <label>Monthly Amount</label>
              <input id="theMonthly" defaultValue={this.props.currentRecord['Monthly Amount']} />
            </div>
            {this.cpopAmount}
          </div>
          <div className="fieldGroup hideGroup">
            <div className="fieldItem theToggle" onClick={(e)=>this.toggleHide(e, 'pre')}>
              <label for="preClean">There is a Pre-Clean</label>
              <input id="preClean" className="theCheck" type="checkbox" />
            </div>
            <div className="fieldItem">
              <label>Pre-Clean Cost</label>
              <input id="preCharge" defaultValue={this.props.currentRecord['Pre-Clean Charge']} />
            </div>
            <div className="fieldItem">
              <label>Pre-Clean Date</label>
              <input id="preDate" type="date" defaultValue={this.props.currentRecord['Pre-Clean Date']} />
            </div>
          </div>


          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Franchise</label>
              <select id="spSelector" value={this.props.currentRecord['SP Number']} onChange={this.spChangeHandler}>
                {this.props.spList.map((e, i) => (
                  <option value={e.fields['Number']}>
                    {e.fields['SP Name']}
                  </option>
                ))}
              </select>
            </div>
            {this.franchiseCharge}
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Order Supplies</label>
              <select id="theSupplies" value={this.props.currentRecord['Orders Supplies']}>
                <option value=""></option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
          </div>

          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    } else if (this.state.formType === 'Crew Change') {
      return (
        <div className="theFields">
          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Old Franchise</label>
              <select id="oldFranch" defaultValue={this.props.currentRecord['SP Number']}>
                {this.props.spList.map((e, i) => (
                  <option {...this.props.currentRecord['SP Number'] === e.fields['Number'] ? 'selected' : ''} value={e.fields['Number']}>
                    {e.fields['SP Name']}
                  </option>
                ))}
              </select>
            </div>

            <div className="fieldItem">
              <label>Last Date of Service</label>
              <input id="lastDate" type="date" />
            </div>

            <div className="fieldGroup">
              <div className="fieldItem">
                <label>Is the revenue replaceable?</label>
                <select id="replaceable">
                  <option></option>
                  <option>Replace 100%</option>
                  <option>Replace 75%</option>
                  <option>Replace 50%</option>
                  <option>Don't replace</option>
                </select>
              </div>
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>New Franchise</label>
              <select id="newFranch">
                {this.props.spList.map((e, i) => (
                  <option value={e.fields['Number']}>
                    {e.fields['SP Name']}
                  </option>
                ))}
              </select>
            </div>

            <div className="fieldItem">
              <label>New SP Start Date</label>
              <input id="newStart" type="date" />
            </div>
          </div>


          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Notes</label>
              <textarea id="theNotes" rows="4" />
            </div>
          </div>


          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    } else if (this.state.formType === 'Account Credit') {
      return (
        <div className="theFields">
          <div className="fieldGroup selectGroup single" id="missedType" onChange={this.switchSelect}>
            <h3>Cleans Missed</h3>
            <br/>
            <div className="fieldItem switchType">
              <select>
                <option value="single">Choose Single Date</option>
                <option value="range">Choose Range of Dates</option>
                <option value="multiple">Enter Multiple Dates</option>
              </select>
            </div>

            <div className="fieldItem single">
              <label>Date Missed</label>
              <input id="dateMissed" type="date" />
            </div>

            <div className="fieldItem range">
              <label>Missed from</label>
              <input id="rangeFrom" type="date" />
            </div>
            <div className="fieldItem range">
              <label>Through</label>
              <input id="rangeTo" type="date" />
            </div>

            <div className="fieldItem multiple">
              <label>Type in Dates (add a comma between each)</label>
              <textarea id="dateMulti" rows="2" />
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Charge the Franchise?</label>
              <select id="chargeFranch">
                <option></option>
                <option>Yes, charge the franchise</option>
                <option>Don't charge the franchise</option>
              </select>
            </div>
          </div>


          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Notes</label>
              <textarea id="theNotes" rows="4" />
            </div>
          </div>


          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    } else if (this.state.formType === 'Additional Service') {
      return (
        <div className="theFields">

          <div className="fieldGroup">
            <div className="fieldItem range">
              <label>Date of Service</label>
              <input id="addtlDate" type="date" />
            </div>
          </div>

          <div className="fieldGroup">
            {this.state.addtlService.map((e, i) => (
              <div className="innerGroup" key={'service-' + i}>
                <div className="fieldItem">
                  <label>Service</label>
                  <input value={e.service} onChange={e=>this.changeServices(e.target.value,i,'service')} />
                </div>

                <div className="fieldItem">
                  <label>Price</label>
                  <input value={e.price} onChange={e=>this.changeServices(e.target.value,i,'price')} />
                </div>

                <div className="btn softGrad--black" onClick={()=>this.removeService(i)}>x</div>
              </div>
            ))}

            <div className="btn softGrad--blue" onClick={this.addService}>Add Service</div>
          </div>


          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Notes</label>
              <textarea id="theNotes" rows="5" />
            </div>
          </div>


          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    } else if (this.state.formType === 'Account Cancellation') {
      return (
        <div className="theFields">
          <div className="fieldGroup">
            <div className="fieldItem range">
              <label>Date of Cancellation</label>
              <input id="stopDate" type="date" />
            </div>
          </div>

          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Is the revenue replaceable?</label>
              <select id="replaceable">
                <option></option>
                <option>Replace 100%</option>
                <option>Replace 75%</option>
                <option>Replace 50%</option>
                <option>Don't replace</option>
              </select>
            </div>
          </div>


          <div className="fieldGroup">
            <div className="fieldItem">
              <label>Notes</label>
              <textarea id="theNotes" rows="5" />
            </div>
          </div>


          <div className="fieldGroup">
            <button className="btn softGrad--blue addForm" type="submit">Save Form</button>
          </div>
        </div>
      );
    }
  }

  get franchiseCharge() {
    if (this.state.theCharge > 0) {

      if (this.state.theSP['Franchise Level'] === '1' || this.state.theSP['Franchise Level'] === '2' || this.state.theSP['Franchise Level'] === '3') {
        return (
          <div className="fieldItem">
            <label>Payment Terms</label>
            <select id="theTerms1">
              <option>1 Month</option>
              <option>3 Months</option>
              <option>6 Months</option>
              <option>12 Months</option>
              <option>18 Months</option>
            </select>
            <input className="termsAt" id="theTerms2" type="text" defaultValue="3x" />
          </div>
        );
      } else {
        return (
          <div className="fieldItem">
            <label>Payment Terms</label>
            <select id="theTerms1">
              <option>1 Month</option>
              <option>3 Months</option>
              <option>6 Months</option>
              <option>12 Months</option>
              <option>18 Months</option>
            </select>
            <input className="termsAt" id="theTerms2" type="text" defaultValue="3x" />
          </div>
        );
      }

    } else {
      return (
        <p>This franchise has ${this.state.thePlan} revenue left to fill.</p>
      )
    }
  }

  get cpopAmount() {
    if (this.props.currentRecord['Monthly CPOP']) {
      return (
        <div className="fieldItem">
          <label>Amount that goes towards CPOP</label>
          <input defaultValue={this.props.currentRecord['Monthly CPOP']} />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/Globals/Modals/FormEdit.js